<div class="rs-wrapper-v4">
    <h3 id="pagos" class="title-payment-queue">Estado de pagos {{system.attributes.name}}</h3>
    <p class="secondary-text">Toda la información de la demora la podrás encontrar en esta sección. A la izquierda,
        podrás visualizar los
        pedidos pendientes con su respectivo progreso, y a la derecha podrás ver los pedidos de nuestros clientes
        que se han completado en las últimas horas.</p>
    <app-empty-component *ngIf="!system.attributes.can_receive || system.relationships.system_information.data[0].attributes.time_average === 0"></app-empty-component>
    <div class="loading" *ngIf="system.attributes.can_receive && system.relationships.system_information.data[0].attributes.time_average !== 0">
        <app-slide [margin]="23" [scrollFromEnd]="true" [elementWidth]="372" [elementQty]="systemPaymentQueue.length"
            [ngStyle]="{opacity: isLoaded ? 1 : 0}">
            <div class="payment-container">
                <ng-container>
                    <app-card-payment-queue [system]="system" [systemPaymentData]="systemPaymentQueue"
                        [paymentId]="paymentId">
                    </app-card-payment-queue>
                    <div class="divider-queue">
                        <div class="dotted-line"></div>
                        <div class="container-isotipo">
                            <img class="isotipo-saldo" width="32" height="auto"
                                src="../../../../assets/images/landing-system/isotipo-saldo.png" alt="Saldo">
                        </div>
                    </div>
                    <app-card-payment-queue [system]="system" [systemPaymentData]="systemPaymentSent" [isSent]="true"
                        [paymentId]="paymentId" [showInitial]="false">
                    </app-card-payment-queue>
                </ng-container>
            </div>
        </app-slide>
        <div class="flex-column-center-center spinner" [ngStyle]="{opacity: isLoaded ? 0 : 1}"
            [ngClass]="{'hidden-spinner':isLoaded}">
            <mat-spinner diameter="80"></mat-spinner>
        </div>
    </div>
</div>
